import { render } from "./siteManager.vue?vue&type=template&id=1d65a5ee"
import script from "./siteManager.vue?vue&type=script&lang=js"
export * from "./siteManager.vue?vue&type=script&lang=js"

import "./siteManager.vue?vue&type=style&index=0&id=1d65a5ee&lang=scss"

import exportComponent from "/Users/mymac/Documents/Digitala/MODC/modc-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__